/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Try_Magic_More_VoicesInputs */

const en_try_magic_more_voices = /** @type {(inputs: Try_Magic_More_VoicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}+ more voices in the app`)
};

const es_try_magic_more_voices = /** @type {(inputs: Try_Magic_More_VoicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}+ voces más en la app`)
};

/**
* | output |
* | --- |
* | "{count}+ more voices in the app" |
*
* @param {Try_Magic_More_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_more_voices = /** @type {((inputs: Try_Magic_More_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_More_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_more_voices(inputs)
	return en_try_magic_more_voices(inputs)
});